import React, { useState, useEffect, useContext } from "react";
import { Label, Form, FormGroup, Row, Col, Input, InputGroup } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import { formatDateTime, getCarTypes, getCorporateClientsBySeviceCityIdAndTravelType, getUserDetails, showAlert } from "../../Services/Shared.service";
import { createPackage, getPackage, getTaxGroupList } from "../../Services/Packages.service";
import { createCorporateClient, getCorporateClient, updateCorporateClient, updateCorporateClientPackagesTaxes } from "../../Services/CorporateClient.service";
import { ArrowDown, ArrowUp } from "react-feather";
import { CommonModal } from "../../AbstractElements";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import { Box, Drawer, Typography } from "@mui/material";
import closeIcon from "../../assets/images/tarrifManagement/closeIcon.svg";
import SharedDataContext from "../../_helper/SharedData";

const CorporateClientInput = ({
  // cityData,
  editId,
  setIsOpen,
  // fetchTableData,
  isOpen,
  refetchClientData,
}) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    reset,
  } = useForm({
    defaultValues: {
      isMegaCabsCompany: false,
      serviceCity: "",
      companyName: "",
      panNo: "",
      serviceTaxNo: "",
      contactPerson: "",
      mobile: "",
      email: "",
      addressLine: "",
      city: "",
      state: "",
      pincode: "",
      fax: "",
      billingAddress: "",
      billingCity: "",
      billingState: "",
      billingPincode: "",
      billingContactPerson: "",
      billingContactMobile: "",
      discountValue: "",
      discountType: "",
      baseFareTax: "",
      serviceTax: "",
      isAirportClient: null,
      airportCharge: "",
      a2c: false,
      c2a: false,
      isWalletEnabled: true,
    },
  });
  const values = getValues();
  const { overallTax } = watch();
  const [taxData, setTaxData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [corporateClientObj, setCorporateClientObj] = useState({});
  const [isAdvanced, setIsAdvanced] = useState(false);
  const { mix_background_layout } = useContext(CustomizerContext);
  const { cityData } = useContext(SharedDataContext);
  const [combinedTax, setCombinedTax] = useState([]);

    const serviceCityField = useController({
        name: "serviceCity",
        control,
        rules: {
            required: {
                value: true,
                message: "Service City is Required",
            },
        },
    }).field;

    const handleServiceCitySelectChange = (data) => {
        serviceCityField.onChange(data.value);
    };

    const isMegaCabsCompanyField = useController({
        name: "isMegaCabsCompany",
        control,
    }).field;

    const isWalletEnabledField = useController({
        name: "isWalletEnabled",
        control,
    }).field;

    const isAirportClientField = useController({
      name: "isAirportClient",
      control,
      rules: {
        validate: (value) => {
          // Check if value is null or undefined (not selected)
          // Both true and false are valid selections
          if (value === null || value === undefined) {
            return "Please select any one of the options";
          }
          return true;
        },
      },
    }).field;

    const a2cField = useController({
        name: "a2c",
        control,
    }).field;

    const c2aField = useController({
        name: "c2a",
        control,
    }).field;

    const mobileField = useController({
        name: "mobile",
        control,
        rules: {
            required: {
                value: true,
                message: "Mobile Number is Required",
            },
        },
    }).field;

    const billingMobileField = useController({
        name: "billingContactMobile",
        control,
    }).field;

    const discountValueField = useController({
        name: "discountValue",
        control,
    }).field;

    const airportChargeField = useController({
        name: "airportCharge",
        control,
    }).field;


    const baseFareTaxField = useController({
        name: "baseFareTax",
        control,
        rules: {
            required: {
                value: true,
                message: "Base Fare Tax is Required",
            },
        },
    }).field;

    const handleBaseFareTax = (data) => {
        baseFareTaxField.onChange(data.value);
    };

    const serviceTaxField = useController({
        name: "serviceTax",
        control,
        rules: {
            required: {
                value: true,
                message: "Service Tax is Required",
            },
        },
    }).field;

    const handleServiceFareTax = (data) => {
        serviceTaxField.onChange(data.value);
    };

  useEffect(() => {
    if (isOpen) {
      getTaxGroupList().then((result) => {
        if (result.status == 200) {
          const data = result.data.map((element) => {
            return {
              value: element,
              label: element.name,
            };
          });

          setCombinedTax(generateTaxCombinationsForSelectBox(result.data));
        }
      });
    }
  }, [isOpen]);

  useEffect(() => {
    if (
      corporateClientObj &&
      corporateClientObj.baseFareTaxId &&
      corporateClientObj.serviceTaxId
    ) {
      const matchedTax = combinedTax.find(
        (item) =>
          item.value.baseTax.taxGroupId === corporateClientObj.baseFareTaxId &&
          item.value.serviceTax.taxGroupId === corporateClientObj.serviceTaxId
      );
      setValue("overallTax", matchedTax);
      setValue("baseFareTax", matchedTax?.value.baseTax);
      setValue("serviceTax", matchedTax?.value.serviceTax);
    } else {
      setValue("overallTax", null);
    }
  }, [corporateClientObj, combinedTax, setValue, isOpen]);

  function generateTaxCombinationsForSelectBox(taxData) {
    let basezero = taxData.filter((t) => t.taxRate === 0);
    let basenonzero = taxData.filter((t) => t.taxRate !== 0);
    console.log("Base Zero :", basezero);
    basezero.sort((a, b) => a.taxCategory.localeCompare(b.taxCategory));
    basenonzero.sort((a, b) => a.taxCategory.localeCompare(b.taxCategory));
    let combinations = [];
    combinations.push({
      label: `Base ${basenonzero[0].taxRate}% Service ${basenonzero[1].taxRate}%`,
      value: { baseTax: basenonzero[0], serviceTax: basenonzero[1] },
    });
    combinations.push({
      label: `Base ${basezero[0].taxRate}% Service ${basezero[1].taxRate}%`,
      value: { baseTax: basezero[0], serviceTax: basezero[1] },
    });
    console.log("");
    console.log("");
    console.log("combinations:", combinations);
    console.log("");
    return combinations;
  }

  useEffect(() => {
    if (editId) {
      getCorporateClient(editId)
        .then((resp) => {
          let corporateClientObj = resp.data;
          setCorporateClientObj(corporateClientObj);
          const serviceCity = cityData.find((element) => {
            return element?.value?.id === corporateClientObj?.serviceCityId;
          });
          console.log("service city", serviceCity);
          reset({
            isMegaCabsCompany: corporateClientObj?.isMegaCabsCompany
              ? true
              : false,
            serviceCity: serviceCity?.value?.id ? serviceCity?.value : "",
            companyName: corporateClientObj?.companyName
              ? corporateClientObj.companyName
              : "",
            panNo: corporateClientObj?.panNo ? corporateClientObj.panNo : "",
            serviceTaxNo: corporateClientObj?.serviceTaxNo
              ? corporateClientObj.serviceTaxNo
              : "",
            contactPerson: corporateClientObj?.contactPerson
              ? corporateClientObj.contactPerson
              : "",
            mobile: corporateClientObj?.mobile ? corporateClientObj.mobile : "",
            email: corporateClientObj?.email ? corporateClientObj.email : "",
            addressLine: corporateClientObj?.addressLine
              ? corporateClientObj.addressLine
              : "",
            city: corporateClientObj?.city ? corporateClientObj.city : "",
            state: corporateClientObj?.state ? corporateClientObj.state : "",
            pincode: corporateClientObj?.pincode
              ? corporateClientObj.pincode
              : "",
            fax: corporateClientObj?.fax ? corporateClientObj.fax : "",
            billingAddress: corporateClientObj?.billingAddress
              ? corporateClientObj.billingAddress
              : "",
            billingCity: corporateClientObj?.billingCity
              ? corporateClientObj.billingCity
              : "",
            billingState: corporateClientObj?.billingState
              ? corporateClientObj.billingState
              : "",
            billingPincode: corporateClientObj?.billingPincode
              ? corporateClientObj.billingPincode
              : "",
            billingContactPerson: corporateClientObj?.billingContactPerson
              ? corporateClientObj.billingContactPerson
              : "",
            billingContactMobile: corporateClientObj?.billingContactMobile
              ? corporateClientObj.billingContactMobile
              : "",
            discountValue: corporateClientObj?.discountValue
              ? corporateClientObj.discountValue
              : "",
            discountType: corporateClientObj?.discountType
              ? corporateClientObj.discountType
              : "",
            baseFareTax: corporateClientObj?.baseFareTaxId
              ? { id: corporateClientObj?.baseFareTaxId }
              : "",
            serviceTax: corporateClientObj?.serviceTaxId
              ? { id: corporateClientObj?.serviceTaxId }
              : "",
            isAirportClient: corporateClientObj?.isAirportClient ? true : false,
            airportCharge: corporateClientObj?.airportCharge
              ? corporateClientObj.airportCharge
              : "",
            a2c: corporateClientObj?.a2c ? true : false,
            c2a: corporateClientObj?.c2a ? true : false,
            isWalletEnabled: corporateClientObj?.isWalletEnabled ? true : false,
          });
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    }
  }, [editId, isOpen]);

  // const onFormSubmit = (formValues) => {
  //   const userDetails = getUserDetails();
  //   setIsSubmitting(true);
  //   const body = {
  //     sapGlCode: null,
  //     isMegaCabsCompany: formValues.isMegaCabsCompany ? true : false,
  //     companyName: formValues.companyName ? formValues.companyName : null,
  //     companyLogo: null,
  //     cinNo: null,
  //     panNo: formValues.panNo ? formValues.panNo : null,
  //     serviceTaxNo: formValues.serviceTaxNo ? formValues.serviceTaxNo : null,
  //     contactPerson: formValues.contactPerson ? formValues.contactPerson : null,
  //     mobile: formValues.mobile ? formValues.mobile : null,
  //     email: formValues.email ? formValues.email : null,
  //     addressLine: formValues.addressLine ? formValues.addressLine : null,
  //     city: formValues.city ? formValues.city : null,
  //     state: formValues.state ? formValues.state : null,
  //     pincode: formValues.pincode ? formValues.pincode : null,
  //     phone1: null,
  //     phone2: null,
  //     fax: formValues.fax ? formValues.fax : null,
  //     billingAddress: formValues.billingAddress
  //       ? formValues.billingAddress
  //       : null,
  //     billingCity: formValues.billingCity ? formValues.billingCity : null,
  //     billingState: formValues.billingState ? formValues.billingState : null,
  //     billingPincode: formValues.billingPincode
  //       ? formValues.billingPincode
  //       : null,
  //     billingContactPerson: formValues.billingContactPerson
  //       ? formValues.billingContactPerson
  //       : null,
  //     billingContactMobile: formValues.billingContactMobile
  //       ? formValues.billingContactMobile
  //       : null,
  //     createdById: userDetails.userId,
  //     createdViaType: null,
  //     deletedOn: null,
  //     isDeleted: false,
  //     deletedById: null,
  //     serviceCityId: formValues.serviceCity?.id
  //       ? formValues.serviceCity.id
  //       : null,
  //     discountValue: formValues.discountValue ? formValues.discountValue : null,
  //     discountType: formValues.discountType ? formValues.discountType : null,
  //     baseFareTaxId: formValues.baseFareTax?.id
  //       ? formValues.baseFareTax.id
  //       : null,
  //     serviceTaxId: formValues.serviceTax?.id ? formValues.serviceTax.id : null,
  //     isAirportClient: formValues.isAirportClient ? true : false,
  //     lutNo: null,
  //     serviceDescription: formValues.serviceCity?.serviceDescription
  //       ? formValues.serviceCity.serviceDescription
  //       : null,
  //     sacCode: formValues.serviceCity?.sacCode
  //       ? formValues.serviceCity.sacCode
  //       : null,
  //     isSendSms: true,
  //     isSendMail: null,
  //     isStopInvoice: null,
  //     a2c: formValues.a2c ? true : false,
  //     c2a: formValues.c2a ? true : false,
  //     airportCharge: formValues.airportCharge
  //       ? Number(formValues.airportCharge)
  //       : null,
  //     isWalletEnabled: formValues.isWalletEnabled ? true : false,
  //   };
  //   if (corporateClientObj?.id) {
  //     body["id"] = corporateClientObj?.id;
  //     updateCorporateClient(body)
  //       .then((result) => {
  //         showAlert("success", "Corporate Client Updated Successfully");
  //         // fetchTableData();
  //         setIsSubmitting(false);
  //         setIsOpen(false);
  //       })
  //       .catch((err) => {
  //         showAlert(
  //           "error",
  //           err.response?.data?.message
  //             ? err.response.data.message
  //             : "Something went wrong"
  //         );
  //         setIsSubmitting(false);
  //       });
  //   } else {
  //     createCorporateClient(body)
  //       .then((result) => {
  //         showAlert("success", "Corporate Client Created Successfully");
  //         // fetchTableData();
  //         setIsSubmitting(false);
  //         setIsOpen(false);
  //       })
  //       .catch((err) => {
  //         showAlert(
  //           "error",
  //           err.response?.data?.message
  //             ? err.response.data.message
  //             : "Something went wrong"
  //         );
  //         setIsSubmitting(false);
  //       });
  //   }
  // };

  const onFormSubmit = (formValues) => {
    const userDetails = getUserDetails();
    setIsSubmitting(true);
    const body = {
      sapGlCode: null,
      isMegaCabsCompany: formValues.isMegaCabsCompany ? true : false,
      companyName: formValues.companyName ? formValues.companyName : null,
      companyLogo: null,
      cinNo: null,
      panNo: formValues.panNo ? formValues.panNo : null,
      serviceTaxNo: formValues.serviceTaxNo ? formValues.serviceTaxNo : null,
      contactPerson: formValues.contactPerson ? formValues.contactPerson : null,
      mobile: formValues.mobile ? formValues.mobile : null,
      email: formValues.email ? formValues.email : null,
      addressLine: formValues.addressLine ? formValues.addressLine : null,
      city: formValues.city ? formValues.city : null,
      state: formValues.state ? formValues.state : null,
      pincode: formValues.pincode ? formValues.pincode : null,
      phone1: null,
      phone2: null,
      fax: formValues.fax ? formValues.fax : null,
      billingAddress: formValues.billingAddress
        ? formValues.billingAddress
        : null,
      billingCity: formValues.billingCity ? formValues.billingCity : null,
      billingState: formValues.billingState ? formValues.billingState : null,
      billingPincode: formValues.billingPincode
        ? formValues.billingPincode
        : null,
      billingContactPerson: formValues.billingContactPerson
        ? formValues.billingContactPerson
        : null,
      billingContactMobile: formValues.billingContactMobile
        ? formValues.billingContactMobile
        : null,
      createdById: userDetails.userId,
      createdViaType: null,
      deletedOn: null,
      isDeleted: false,
      deletedById: null,
      serviceCityId: formValues.serviceCity?.id
        ? formValues.serviceCity.id
        : null,
      discountValue: formValues.discountValue ? formValues.discountValue : null,
      discountType: formValues.discountType ? formValues.discountType : null,
      baseFareTaxId: formValues.baseFareTax?.taxGroupId
        ? formValues.baseFareTax.taxGroupId
        : null,
      serviceTaxId: formValues.serviceTax?.taxGroupId
        ? formValues.serviceTax.taxGroupId
        : null,

      isAirportClient: formValues.isAirportClient ? true : false,
      lutNo: null,
      serviceDescription: formValues.serviceCity?.serviceDescription
        ? formValues.serviceCity.serviceDescription
        : null,
      sacCode: formValues.serviceCity?.sacCode
        ? formValues.serviceCity.sacCode
        : null,
      isSendSms: true,
      isSendMail: null,
      isStopInvoice: null,
      a2c: formValues.a2c ? true : false,
      c2a: formValues.c2a ? true : false,
      airportCharge: formValues.airportCharge
        ? Number(formValues.airportCharge)
        : null,
      isWalletEnabled: true,
    };
    if (corporateClientObj?.id) {
      body["id"] = corporateClientObj?.id;
      updateCorporateClient(body)
        .then((resp) => {
          reset({
            isMegaCabsCompany: false,
            serviceCity: "",
            companyName: "",
            panNo: "",
            serviceTaxNo: "",
            contactPerson: "",
            mobile: "",
            email: "",
            addressLine: "",
            city: "",
            state: "",
            pincode: "",
            fax: "",
            billingAddress: "",
            billingCity: "",
            billingState: "",
            billingPincode: "",
            billingContactPerson: "",
            billingContactMobile: "",
            discountValue: "",
            discountType: "",
            baseFareTax: "",
            serviceTax: "",
            isAirportClient: false,
            airportCharge: "",
            a2c: false,
            c2a: false,
            isWalletEnabled: false,
          });
          const updatePackageTaxBody = {
            corporateClientId: resp?.data?.id,
            serviceTaxId: resp?.data?.serviceTaxId,
            basefareTaxId: resp?.data?.baseFareTaxId,
            serviceTaxName: resp?.data?.serviceTaxName ? resp?.data?.serviceTaxName : "",
            basefareTaxName: resp?.data?.baseFareTaxName ? resp?.data?.baseFareTaxName : "",
            // isAirportExpress: resp?.data?.isAirportClient ? false : true,
          };
          updateCorporateClientPackagesTaxes(updatePackageTaxBody).then((resp) => {
          }).catch((err) => {
            showAlert(
              "error",
              err.response?.data?.message
                ? err.response.data.message
                : "Something went wrong"
            );
          });
          showAlert("success", "Corporate Client Updated Successfully");
          // fetchTableData();
          if (refetchClientData) {
            refetchClientData();
          }
          setIsSubmitting(false);
          setIsOpen(!isOpen);
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
          setIsSubmitting(false);
          setIsOpen(!isOpen);
        });
    } else {
      createCorporateClient(body)
        .then((resp) => {
          reset({
            isMegaCabsCompany: false,
            serviceCity: "",
            companyName: "",
            panNo: "",
            serviceTaxNo: "",
            contactPerson: "",
            mobile: "",
            email: "",
            addressLine: "",
            city: "",
            state: "",
            pincode: "",
            fax: "",
            billingAddress: "",
            billingCity: "",
            billingState: "",
            billingPincode: "",
            billingContactPerson: "",
            billingContactMobile: "",
            discountValue: "",
            discountType: "",
            baseFareTax: "",
            serviceTax: "",
            isAirportClient: false,
            airportCharge: "",
            a2c: false,
            c2a: false,
            isWalletEnabled: false,
          });
          showAlert("success", "Corporate Client Created Successfully");
          setIsOpen(!isOpen);
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
          setIsSubmitting(false);
          setIsOpen(!isOpen);
        });
    }
  };
  const handleAirportClientChange = () => {
    setValue("isAirportClient", true);
    setValue("a2c", true);
    setValue("c2a", false);
  };

  const handleCityClientChange = () => {
    setValue("isAirportClient", false);
    setValue("a2c", false);
    setValue("c2a", true);
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={() => setIsOpen(!isOpen)}
      PaperProps={{
        sx: {
          width: "43vw",
          borderTopLeftRadius: "1.49vw",
          borderBottomLeftRadius: "1.49vw",
        },
      }}
      sx={{
        "& .MuiDrawer-paper": {
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE & Edge
          "&::-webkit-scrollbar": {
            display: "none", // Chrome, Safari
          },
        },
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            flex: 1,
            backgroundColor: "rgba(244, 247, 253, 1)",
            height: "3vw",
          }}
        >
          <Box
            sx={{
              paddingTop: "1vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "35%",
            }}
          >
            <img
              src={closeIcon}
              alt={"close"}
              style={{ width: "1.79vw", height: "1.79vw", cursor: "pointer" }}
              onClick={() => setIsOpen(!isOpen)}
            />
            <Box
              sx={{
                width: "0.56vw",
                height: "0.56vw",
                background: "rgba(57, 181, 74, 1)",
                borderRadius: "30%",
              }}
            />
            <Typography
              sx={{
                color: "rgba(57, 181, 74, 1)",
                fontSize: "1.11vw",
                fontWeight: "600",
              }}
            >
              {editId ? "Edit Corporate Client" : "Create Corporate Client"}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            marginX: "1.04vw",
            marginTop: "0.69vw",
            // border: "1px solid red",
            paddingX: "0.69vw",
          }}
        >
          <Form onSubmit={handleSubmit(onFormSubmit)}>
            <Row style={{ display: "flex", justifyContent: "left" }}>
              {/* <FormGroup
                className="col-lg-5"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  className={
                    mix_background_layout == "dark-only"
                      ? "checkbox-dark p-0"
                      : "checkbox p-0"
                  }
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Input
                    id="isMegaCabsCompany"
                    type="checkbox"
                    checked={isMegaCabsCompanyField.value}
                    onChange={(value) => isMegaCabsCompanyField.onChange(value)}
                  />
                  <Label className="mb-0" for="isMegaCabsCompany">
                    {"Is MegaCabs Company"}
                  </Label>
                </div>
              </FormGroup> */}
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Company Name</Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("companyName", {
                      required: {
                        value: true,
                        message: "Company Name is required",
                      },
                      onChange: (e) => {
                        setValue("companyName", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.companyName?.message}
                  </span>
                </Col>
              </FormGroup>
              {/* <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Client Type</Label>
                <Col lg="12">
                  <div
                    className="m-checkbox-inline mb-0 custom-radio-ml"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {/* Airport → City (true) *\/}
                    <div className="radio radio-primary">
                      <Input
                        id="radioinline2"
                        type="radio"
                        name="airportClient"
                        checked={isAirportClientField.value === true}
                        onChange={() => {
                          isAirportClientField.onChange(true);
                          setValue("a2c", true, { shouldValidate: true });
                          setValue("c2a", false, { shouldValidate: true });
                        }}
                      />
                      <Label className="mb-0" for="radioinline2">
                        Airport To City
                      </Label>
                    </div>

                    {/* City → Airport (false) *\/}
                    <div className="radio radio-primary">
                      <Input
                        id="radioinline3"
                        type="radio"
                        name="airportClient"
                        checked={isAirportClientField.value === false}
                        onChange={() => {
                          isAirportClientField.onChange(false);
                          setValue("a2c", false, { shouldValidate: true });
                          setValue("c2a", true, { shouldValidate: true });
                        }}
                      />
                      <Label className="mb-0" for="radioinline3">
                        City To Airport
                      </Label>
                    </div>
                  </div>

                  {/* Error message below radio buttons *\/}
                  <span style={{ color: "red" }}>
                    {errors?.isAirportClient?.message}
                  </span>
                </Col>
              </FormGroup> */}
            </Row>
            <Row style={{ display: "flex", justifyContent: "space-around" }}>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Service City</Label>
                <Col lg="12">
                  <div className="city-select">
                    <CustomSelect
                      className="service-select"
                      classNamePrefix="select"
                      isClearable={false}
                      isSearchable={false}
                      value={
                        serviceCityField?.value?.id
                          ? cityData.find((element) => {
                              return (
                                element?.value?.id ===
                                serviceCityField?.value?.id
                              );
                            })
                          : ""
                      }
                      isDisabled={corporateClientObj?.id ? true : false}
                      // defaultValue={cityData.find((element) => {
                      //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                      //   return element?.value?.id === cityField?.value?.id;
                      // })}
                      onChange={handleServiceCitySelectChange}
                      placeholder="Select City"
                      options={cityData}
                    />
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.serviceCity?.message}
                  </span>
                </Col>
              </FormGroup>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Contact Person
                </Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("contactPerson", {
                      required: {
                        value: true,
                        message: "Contact Person is required",
                      },
                      onChange: (e) => {
                        setValue("contactPerson", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.contactPerson?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>
            <Row style={{ display: "flex", justifyContent: "space-around" }}>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Address</Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("addressLine", {
                      required: {
                        value: true,
                        message: "Address is required",
                      },
                      onChange: (e) => {
                        setValue("addressLine", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.addressLine?.message}
                  </span>
                </Col>
              </FormGroup>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">City</Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("city", {
                      required: {
                        value: true,
                        message: "City is required",
                      },
                      onChange: (e) => {
                        setValue("city", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>{errors?.city?.message}</span>
                </Col>
              </FormGroup>
            </Row>
            <Row style={{ display: "flex", justifyContent: "space-around" }}>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Mobile Number
                </Label>
                <Col lg="12">
                  <input
                    type="text"
                    className="form-control"
                    maxLength={10}
                    value={mobileField.value}
                    pattern="[0-9]+"
                    onChange={(e) => {
                      mobileField.onChange(
                        e.target.value.replace(/[^0-9]/g, "")
                      );
                    }}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.mobile?.message}
                  </span>
                </Col>
              </FormGroup>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Email</Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("email", {
                      onChange: (e) => {
                        setValue("email", e.target.value.trimStart());
                      },
                      required: {
                        value: true,
                        message: "Email is required",
                      },
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: "Please enter a valid email !",
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>{errors?.email?.message}</span>
                </Col>
              </FormGroup>
            </Row>
            <Row style={{ display: "flex", justifyContent: "space-around" }}>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Email</Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("email", {
                      onChange: (e) => {
                        setValue("email", e.target.value.trimStart());
                      },
                      required: {
                        value: true,
                        message: "Email is required",
                      },
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: "Please enter a valid email !",
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>{errors?.email?.message}</span>
                </Col>
              </FormGroup>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">State</Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("state", {
                      required: {
                        value: true,
                        message: "State is required",
                      },
                      onChange: (e) => {
                        setValue("state", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>{errors?.state?.message}</span>
                </Col>
              </FormGroup>
            </Row>
            <Row style={{ display: "flex", justifyContent: "flex-start" }}>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Tax</Label>
                <Col lg="12">
                  <div className="city-select">
                    <Select
                      value={overallTax}
                      {...register("overallTax")}
                      onChange={(e) => {
                        setValue("overallTax", e);
                        setValue("baseFareTax", e.value.baseTax);
                        setValue("serviceTax", e.value.serviceTax);
                        showAlert("warning", "Updating the client tax will also update all linked package taxes.Press Update to proceed");
                      }}
                      placeholder={"Select Tax"}
                      options={combinedTax}
                    />
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.serviceTax?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>

            <Row style={{ display: "flex", justifyContent: "space-around" }}>
              {/* <FormGroup
                className="col-lg-6"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  className="m-checkbox-inline mb-0 custom-radio-ml"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className="radio radio-primary">
                    <Input
                      id="radioinline2"
                      type="radio"
                      name="airportClient"
                      checked={isAirportClientField.value}
                      onChange={handleAirportClientChange}
                    />
                    <Label className="mb-0" for="radioinline2">
                      {"Airport To City"}
                    </Label>
                  </div>
                  <div className="radio radio-primary">
                    <Input
                      id="radioinline3"
                      type="radio"
                      name="cityClient"
                      checked={c2aField.value}
                      onChange={handleCityClientChange}
                    />
                    <Label className="mb-0" for="radioinline3">
                      {"City To Airport"}
                    </Label>
                  </div>
                </div>
              </FormGroup> */}
              {/* <FormGroup
                className="col-lg-6"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  className={
                    mix_background_layout == "dark-only"
                      ? "checkbox-dark p-0"
                      : "checkbox p-0"
                  }
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Input
                    id="isWalletEnabled"
                    type="checkbox"
                    checked={isWalletEnabledField.value}
                    onChange={(value) => isWalletEnabledField.onChange(value)}
                  />
                  <Label className="mb-0" for="isWalletEnabled">
                    {"Wallet Enabled"}
                  </Label>
                </div>
              </FormGroup> */}
            </Row>
            <Row
              style={{
                display: "flex",
                flexDirection: "flex-start",
              }}
            >
              <div
                style={{
                  color: "#11BF5C",
                  textDecoration: "underline",
                  display: "flex",
                  alignItems: "center",
                  // justifyContent: "flex-end",
                  cursor: "pointer",
                }}
                onClick={() => setIsAdvanced(!isAdvanced)}
              >
                Advanced Configurations{" "}
                {isAdvanced ? (
                  <ArrowUp
                    style={{ width: "15px", height: "15px", marginLeft: "5px" }}
                  />
                ) : (
                  <ArrowDown
                    style={{ width: "15px", height: "15px", marginLeft: "5px" }}
                  />
                )}
              </div>
            </Row>
            {isAdvanced ? (
              <>
                <Row
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Pan Number
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("panNo", {
                          onChange: (e) => {
                            setValue("panNo", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.panNo?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Service Tax Number
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("serviceTaxNo", {
                          onChange: (e) => {
                            setValue(
                              "serviceTaxNo",
                              e.target.value.trimStart()
                            );
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.serviceTaxNo?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">Pincode</Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("pincode", {
                          // onChange: (e) => {
                          //   const onlyNumbers = e.target.value.replace(/\D/g, "");
                          //   setValue("pincode", onlyNumbers.trimStart());
                          // },
                          onChange: (e) => {
                            const onlyNumbers = e.target.value.replace(
                              /\D/g,
                              ""
                            );
                            setValue("pincode", onlyNumbers, {
                              shouldDirty: true,
                            });
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.pincode?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">Fax</Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("fax", {
                          onChange: (e) => {
                            setValue("fax", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.fax?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Billing Address
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("billingAddress", {
                          onChange: (e) => {
                            setValue(
                              "billingAddress",
                              e.target.value.trimStart()
                            );
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.billingAddress?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Billing City
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("billingCity", {
                          onChange: (e) => {
                            setValue("billingCity", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.billingCity?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Billing State
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("billingState", {
                          onChange: (e) => {
                            setValue(
                              "billingState",
                              e.target.value.trimStart()
                            );
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.billingState?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Billing Pincode
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("billingPincode", {
                          onChange: (e) => {
                            setValue(
                              "billingPincode",
                              e.target.value.trimStart()
                            );
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.billingPincode?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Billing Contact Person
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("billingContactPerson", {
                          onChange: (e) => {
                            setValue(
                              "billingContactPerson",
                              e.target.value.trimStart()
                            );
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.billingContactPerson?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Billing Contact Mobile
                    </Label>
                    <Col lg="12">
                      <input
                        type="text"
                        className="form-control"
                        maxLength={10}
                        value={billingMobileField.value}
                        pattern="[0-9]+"
                        onChange={(e) => {
                          billingMobileField.onChange(
                            e.target.value.replace(/[^0-9]/g, "")
                          );
                        }}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.billingContactMobile?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  {/* <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Discount Value
                    </Label>
                    <Col lg="12">
                      <input
                        type="text"
                        className="form-control"
                        value={discountValueField.value}
                        pattern="[0-9]+"
                        onChange={(e) => {
                          discountValueField.onChange(
                            e.target.value.replace(/[^0-9]/g, "")
                          );
                        }}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.discountValue?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Discount Type
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("discountType", {
                          onChange: (e) => {
                            setValue(
                              "discountType",
                              e.target.value.trimStart()
                            );
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.discountType?.message}
                      </span>
                    </Col>
                  </FormGroup> */}
                </Row>
                <Row style={{ display: "flex", justifyContent: "flex-start" }}>
                  <FormGroup className="col-lg-6" style={{}}>
                    <Label className="col-lg-12 col-form-label">
                      Airport Charge
                    </Label>
                    <Col lg="12">
                      <input
                        type="text"
                        className="form-control"
                        value={airportChargeField.value}
                        pattern="[0-9]+"
                        onChange={(e) => {
                          airportChargeField.onChange(
                            e.target.value.replace(/[^0-9]/g, "")
                          );
                        }}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.airportCharge?.message}
                      </span>
                    </Col>
                  </FormGroup>
                </Row>
              </>
            ) : null}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "2vw",
              }}
            >
              <button
                type="submit"
                className="btn submit-button"
                disabled={isSubmitting}
              >
                {corporateClientObj?.id ? "Update" : "Create"}
              </button>
            </div>
          </Form>
        </Box>

        {/* </Box> */}
      </Box>
    </Drawer>
  );
};

export default CorporateClientInput